import { imageUrl } from '@helpers/image';
import { useInView } from '@hooks/useInView';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import * as React from 'react';
import S from './ContentIntroSection.styles';
export var Layout;
(function (Layout) {
    Layout[Layout["LAYOUT_1"] = 1] = "LAYOUT_1";
    Layout[Layout["LAYOUT_2"] = 2] = "LAYOUT_2";
    Layout[Layout["LAYOUT_3"] = 3] = "LAYOUT_3";
    Layout[Layout["LAYOUT_4"] = 4] = "LAYOUT_4";
    Layout[Layout["LAYOUT_5"] = 5] = "LAYOUT_5";
    Layout[Layout["LAYOUT_6"] = 6] = "LAYOUT_6";
    Layout[Layout["LAYOUT_7"] = 7] = "LAYOUT_7";
})(Layout || (Layout = {}));
const ContentIntroSection = ({ content, cta, id, image1, image2, layout, title, }) => {
    const [refContainer, inView] = useInView({ rootMargin: '0px 0px -30% 0px' });
    return (React.createElement(S.Container, { ref: refContainer, id: id, "data-inview": inView, "data-layout": layout, "data-image-padding": layout === Layout.LAYOUT_2 && !!image2 },
        React.createElement(S.Inner, null,
            React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title),
            React.createElement(S.ContentWrapper, null,
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { buttonType: "default", href: cta.url, target: cta.target }, cta.text)))),
            image1 && (React.createElement(S.Image1, null,
                React.createElement(S.Image, { alt: image1.altText, loading: "lazy", src: imageUrl(image1, { width: 492 }) }),
                image1.caption1 && (React.createElement(S.CaptionWrapper, null,
                    image1.caption1 && React.createElement(S.Caption1, null, image1.caption1),
                    image1.caption2 && React.createElement(S.Caption2, null, image1.caption2))))),
            image2 && (React.createElement(S.Image2, null,
                React.createElement(S.Image, { alt: image2.altText, loading: "lazy", src: imageUrl(image2, { width: 492 }) }),
                image2.caption1 && (React.createElement(S.CaptionWrapper, null,
                    image2.caption1 && React.createElement(S.Caption1, null, image2.caption1),
                    image2.caption2 && React.createElement(S.Caption2, null, image2.caption2))))))));
};
export default ContentIntroSection;
